import type { FloatingButtonVariant, Step, StepActionType } from './types'

type StepTransitions = {
  [key in Step]?: {
    [actionType in StepActionType]?: Step
  }
}

export const steps: StepTransitions = {
  WHERE_TO_DELIVER: {
    onCreateNewAddress: 'FIND_ADDRESS_BY_TEXT',
    onCreateAddressFromCurrentLocation: 'ADDRESS_TYPE_FORM',
    onEditAddress: 'ADDRESS_DETAILS_FORM',
    onMapInteraction: 'FIND_ADDRESS_ON_MAP',
    onEditAddressWithoutDetails: 'ADDRESS_TYPE_FORM',
  },
  FIND_ADDRESS_ON_MAP: {
    useSearchInstead: 'FIND_ADDRESS_BY_TEXT',
    onLocationSelected: 'ADDRESS_TYPE_FORM',
    onBack: 'WHERE_TO_DELIVER',
  },
  FIND_ADDRESS_BY_TEXT: {
    onLocationSelected: 'ADDRESS_TYPE_FORM',
    onLocationIsOutOfZone: 'FIND_ADDRESS_ON_MAP',
    onBack: 'WHERE_TO_DELIVER',
    useMapInstead: 'FIND_ADDRESS_ON_MAP',
  },
  ADDRESS_TYPE_FORM: {
    onNext: 'ADDRESS_DETAILS_FORM',
    onBack: 'WHERE_TO_DELIVER',
    onBackToFindByText: 'FIND_ADDRESS_BY_TEXT',
    onMapInteraction: 'FIND_ADDRESS_ON_MAP',
  },
  ADDRESS_DETAILS_FORM: {
    onBack: 'ADDRESS_TYPE_FORM',
    onBackToAddressList: 'WHERE_TO_DELIVER',
    onEditAddressLine: 'FIND_ADDRESS_BY_TEXT',
    onSetEntrance: 'SET_ENTRANCE',
  },
  SET_ENTRANCE: {
    onBack: 'ADDRESS_DETAILS_FORM',
  },
}

export const floatingButtonVariants: Record<Step, FloatingButtonVariant | null> = {
  WHERE_TO_DELIVER: 'CLOSE',
  FIND_ADDRESS_ON_MAP: 'BACK',
  FIND_ADDRESS_BY_TEXT: null,
  ADDRESS_TYPE_FORM: 'BACK',
  ADDRESS_DETAILS_FORM: null,
  SET_ENTRANCE: 'BACK',
}
